import axios from "axios";
import { bscapidetails, idTorpc } from "./Constents";
import Web3 from 'web3'
import { EthereumProvider } from '@walletconnect/ethereum-provider'
import { USDm } from "./ABI";

export const userNativeBalanceOfChain = async (userAddress) => {
  try {
    const data = await axios
      .post(idTorpc["56"], {
        jsonrpc: "2.0",
        method: "eth_getBalance",
        params: [userAddress, "latest"],
        id: 880,
      })
      .then((res) => {
        const bal = parseInt(res.data.result, 16) / 10 ** 18;
        return Number(bal);
      })
      .catch((error) => {
        console.log(error);
      });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export const MaalPriceInDollar = async () => {
  try {
    const price = await axios
      .get("https://backendapi-mainnet.maalscan.io/api/v2/stats")
      .then((res) => {
        return Number(res.data.coin_price);
      })
      .catch((err) => {
        return Number(0.146684);
      });
    return price;
  } catch (error) {
    console.log(error);
    return 0;
  }
};

export const coinGeckotokensPrice = async (tokenID) => {
  try {
    const price = await axios
      .get(
        `https://pro-api.coingecko.com/api/v3/simple/price?ids=${tokenID}&vs_currencies=usd&precision=6&include_market_cap=true&include_24hr_vol=true&include_24hr_change=true&include_last_updated_at=true&x_cg_pro_api_key=CG-3cFZHArKNfDpmqA2hgAfFxgo`
      )
      .then((res) => {
        return res.data[`${tokenID}`].usd;
      })
      .catch((err) => {});
    return price;
  } catch (error) {
    console.log(error);
  }
};

export const maalNativeBalance = async (userAddress) => {
  try {
    const data = await axios
      .post(idTorpc["7862"], {
        jsonrpc: "2.0",
        method: "eth_getBalance",
        params: [userAddress, "latest"],
        id: 880,
      })
      .then((res) => {
        const bal = parseInt(res.data.result, 16) / 10 ** 18;
        return Number(bal);
      })
      .catch((error) => {
        console.log(error);
      });
    return data;
  } catch (error) {
    console.log(error);
  }
};

export async function postTransaction( txhash, txType, Amount, Network, explorer) {
  function formatDateUTC(date) {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const d = new Date(date);
    const month = months[d.getUTCMonth()];
    const day = String(d.getUTCDate()).padStart(2, '0');
    const year = d.getUTCFullYear();
    let hour = d.getUTCHours();
    const min = String(d.getUTCMinutes()).padStart(2, '0');
    const sec = String(d.getUTCSeconds()).padStart(2, '0');
    const ampm = hour >= 12 ? 'PM' : 'AM';
    hour = hour % 12;
    hour = hour ? hour : 12;
    const hourStr = String(hour).padStart(2, '0');
    return `${month}-${day}-${year} ${hourStr}:${min}:${sec} ${ampm} UTC`;
  }
  const data = {
    txhash: txhash,
    txType: txType,
    Amount: Amount,
    Time: formatDateUTC(Date.now()),
    Network: Network,
    explorer: explorer
  };
  try {
    const response = await axios.post(`${bscapidetails.BSC_API_URL_POST}`, data);
    console.log('Response:', response.data);
  } catch (error) {
    console.error('Error posting transaction:', error.response ? error.response.data : error.message);
  }
}

export const fetchEVMChainbalance = async (userAddress, chainid) => {
  try {
    const data = await axios
      .post(idTorpc[chainid], {
        jsonrpc: "2.0",
        method: "eth_getBalance",
        params: [userAddress, "latest"],
        id: 880,
      })
      .then((res) => {
        const bal = parseInt(res.data.result, 16) / 10 ** 18;
        return Number(bal);
      })
      .catch((error) => {
        console.log(error);
      });
    return data;
  } catch (error) {
    console.log(error);
  }
};

// for eusd price
// axios
//   .get(
//     "https://pro-api.coingecko.com/api/v3/simple/price?ids=tether-eurt&vs_currencies=usd&x_cg_pro_api_key=CG-3cFZHArKNfDpmqA2hgAfFxgo"
//   )
//   .then((res) => {
//     setEUSD(res.data[`tether-eurt`].usd);
//   })
//   .catch((err) => {});







let web3 = "";
var provider;
var walletprovider;

const walletConnectProv = async()=>{
  provider = await EthereumProvider.init({
    projectId:'b9bd638e50d4ce444f33b0499cac8433',
    chains: [1],
    showQrModal: true,
    methods: [
      "eth_sendTransaction",
      "eth_signTransaction",
      "eth_sign",
      "personal_sign",
      "eth_signTypedData",
    ],
    events: ["chainChanged", "accountsChanged"]
  })
  return provider
}


export const WalletConnect = async () => {
  try {
    provider = await walletConnectProv()
    await provider.disconnect()
    const data = await provider.enable()
    web3 = new Web3(provider)
    walletprovider = provider
  } catch (error) {
    console.log(error)
  }
}

export const DissconnectWallet = async () => {
  provider = await walletConnectProv()
  await provider.disconnect()
  web3 = null
}






export const getUserAddress = async () => {
  try {
    const address = await web3.eth.getAccounts()
    return address[0]
  } catch (error) {
    // console.log(error)
  }
}

export const get_ERC_20_Contract= async (address) => {
    try {
    const Contract = new web3.eth.Contract(USDm, address)
    return Contract
    } catch (error) {
      // console.log(error)
    }
  }


export const get_Token_Balance = async (tokenAddress, userAddress) => {
  try {
    const Contract = await get_ERC_20_Contract(tokenAddress)
    const balance = await Contract.methods.balanceOf(userAddress).call();
    const bal = await fromwie(balance)
    return Number(bal)
  } catch (error) {
    console.log(error)
  }
}

export const towie = async (amount) => {
  try {
    const number = await web3.utils.toWei(amount.toString(), 'ether')
    return number
  } catch (error) {
    // console.log(error)
  }
}

export const fromwie = async (amount) => {
  try {
    const number = await web3.utils.fromWei(amount.toString(), 'ether')
    return number
  } catch (error) {
    // console.log(error)
  }
}



export const userBalanceOfChain = async (userAddress) => {
  try {
     const data = await axios.post('https://node1-mainnet.maalscan.io/', {
      "jsonrpc": "2.0",
      "method": "eth_getBalance",
      "params": [userAddress, "latest"],
      "id": 1
    }).then(async(res) => {
      const bal = await fromwie(parseInt(res.data.result, 16))
      return Number(bal)
    }).catch((error) => {
      console.log(error)
    })
    return data
  } catch (error) {
    console.log(error)
  }
}


export const convertToLowercase =(str)=> {
  let result = '';
  for (let i = 0; i < str.length; i++) {
    let charCode = str.charCodeAt(i);
    if (charCode >= 65 && charCode <= 90) {
      result += String.fromCharCode(charCode + 32);
    } else {
      result += str.charAt(i);
    }
  }
  return result;
}




export const Approve = async (spender, tokenAddress) => {
  try {
    const contract = await get_ERC_20_Contract(tokenAddress)
  const data = await contract.methods.approve(spender,115792089237316195423570985008687907853269984665640564039457584007913129639935n,).send({ from: await getUserAddress() })
  return data
  } catch (error) {
    console.log(error)
  }
}
export const Allow = async(owner, tokenAddress, spender)=>{
  try {
    const contract = await get_ERC_20_Contract(tokenAddress)
    const data = await contract.methods.allowance(owner, spender).call();
    return data;
  } catch (error) {
    console.log(error)
  }
}

export const mainprovider = ()=>{
  return walletprovider
}